export const BtProvisioningService = {
  BROKER_CONFIGURED: '0a1a9004-0382-4aea-bff4-6b3f1c5adfb4',
  MQTT_PASSWORD: '081a9004-0382-4aea-bff4-6b3f1c5adfb4',
  MQTT_USERNAME: '071a9004-0382-4aea-bff4-6b3f1c5adfb4',
  SERIAL_NUMBER: '0c1a9004-0382-4aea-bff4-6b3f1c5adfb4',
  SERVICE: '021a9004-0382-4aea-bff4-6b3f1c5adfb4',
  WIFI_NETWORKS: '091a9004-0382-4aea-bff4-6b3f1c5adfb4',
  WIFI_PASSWORD: '041a9004-0382-4aea-bff4-6b3f1c5adfb4',
  WIFI_SSID: '031a9004-0382-4aea-bff4-6b3f1c5adfb4',
};
